package com.devi3east.bashbuddy.features.events.common

import com.devi3east.bashbuddy.dashboard.responses.PrizeListResponse
import com.devi3east.bashbuddy.features.events.common.data.api.EventApi
import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.detail.responses.EventDetailResponse
import com.devi3east.bashbuddy.features.events.feed.responses.EventFeedResponse
import com.devi3east.bashbuddy.footer.requests.ContactFormRequest

class EventRepositoryImpl(
    private val api: EventApi
) : EventRepository {

    override suspend fun getEventsList(): Result<EventFeedResponse> = try {
        val response = api.getAllEvents()
        Result.success(response)
    } catch (e: Exception) {
        Result.failure(e)
    }

    override suspend fun getUserCount(): Int? = try {
        api.getUserCount()
    } catch (e: Exception) {
        null
    }

    override suspend fun getEventById(eventId: String): Result<EventDetailResponse> = try {
        val response = api.getEventById(eventId)
        Result.success(response)
    } catch (e: Exception) {
        Result.failure(e)
    }

    override suspend fun getFavoriteEvents(token: String): List<Event> = try {
        api.getFavoriteEvents(token)
    } catch (e: Exception) {
        emptyList()
    }

    override suspend fun addFavorite(token: String, eventId: String): Boolean = try {
        api.addFavoriteEvent(token, eventId)
    } catch (e: Exception) {
        false
    }

    override suspend fun removeFavorite(token: String, eventId: String): Boolean = try {
        api.removeFavoriteEvent(token, eventId)
    } catch (e: Exception) {
        false
    }

    override suspend fun getPrizesByEventId(eventId: String): Result<PrizeListResponse> = try {
        val response = api.getPrizesByEventId(eventId)
        Result.success(response)
    } catch (e: Exception) {
        Result.failure(e)
    }

    override suspend fun sendContact(form: ContactFormRequest): Result<String> {
        return api.sendContactForm(form)
    }

}